<template>
  <div>
    <bottom-bar/>
    <div class="content">
      <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
      <div v-show="!load">
        <div class="container">
          <div class="container-logo">
            <div class="logo-empresa" :style="'background-image: url('+ (empresa.url_capa ? empresa.url_capa : base_cdn + '/static/imgs/default.png') +')'"></div>
          </div>
          <company-header class="mb-3" :empresa="empresa" :fallback="base_cdn + '/static/imgs/default.png'" :show-status="empresa.id_theme === '1'" heading-tag="h4"/>
          <div class="info-body">
            <div>
              <section class="info-section" v-if="empresa.telefone || empresa.whatsapp">
                <h5 class="info-section-title">Contato</h5>
                <div class="contact-grid">
                  <a :href="'https://api.whatsapp.com/send?phone=55' + empresa.whatsapp" target="_blank" rel="noopener" class="contact-action whatsapp" v-if="empresa.whatsapp">
                    <span class="contact-icon"><i class="fa fa-whatsapp"></i></span>
                    <span><small>WhatsApp</small><strong>{{empresa.whatsapp | phone}}</strong></span>
                    <i class="fa fa-angle-right action-arrow"></i>
                  </a>
                  <a :href="'tel:' + empresa.telefone" class="contact-action" aria-label="Telefone da empresa" v-if="empresa.telefone">
                    <span class="contact-icon"><icon name="cellphone" size="20"/></span>
                    <span><small>Telefone</small><strong>{{empresa.telefone | phone}}</strong></span>
                    <i class="fa fa-angle-right action-arrow"></i>
                  </a>
                </div>
              </section>

              <section class="info-section" v-if="empresa.json_config.endereco_empresa === '1'">
                <h5 class="info-section-title">Localização</h5>
                <a :href="googleMapsUrl" target="_blank" rel="noopener" class="info-card info-card-row location-action">
                  <span class="section-icon"><icon name="address" size="20"/></span>
                  <div>
                    <div class="info-label">Endereço</div>
                    <div class="info-value">
                      {{empresa.endereco}}, {{empresa.numero}}<span v-if="empresa.complemento">, {{empresa.complemento}}</span><br>
                      {{empresa.bairro}}, {{empresa.nome_cidade}} - {{empresa.sigla_estado}}
                    </div>
                  </div>
                  <i class="fa fa-angle-right action-arrow"></i>
                </a>
              </section>

              <section class="info-section" v-if="empresa.pagamentos && empresa.pagamentos.length">
                <h5 class="info-section-title">Formas de Pagamento</h5>
                <div class="info-card payment-groups">
                  <div class="payment-group" v-if="pagamentosEntrega.length">
                    <div class="info-label payment-group-title">Pagamento na Entrega</div>
                    <div class="payment-grid">
                      <div class="payment-item" v-for="(p, index) in pagamentosEntrega" :key="p.id_pagamento || index">
                        <span class="payment-logo"><img :src="p.img_pagamento" alt=""></span>
                        <span>{{p.nome_pagamento}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="payment-group" v-if="pagamentosOnline.length">
                    <div class="info-label payment-group-title">Pagamento Online</div>
                    <div class="payment-grid">
                      <div class="payment-item" v-for="(p, index) in pagamentosOnline" :key="p.id_pagamento || index">
                        <span class="payment-logo"><img :src="p.img_pagamento" alt=""></span>
                        <span>{{p.nome_pagamento}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="info-section" v-if="horarios.length > 0">
                <h5 class="info-section-title">Horários de Funcionamento</h5>
                <div class="info-card schedule-card">
                  <div class="schedule-row" v-for="d in horarios" :key="d.dia">
                    <strong>{{d.dia | getDay}}</strong>
                    <span v-if="d.horarios.length"><span v-for="(h, index) in d.horarios" :key="index"><span v-if="index"> · </span><span role="timer">{{h.horario_inicio}}</span> às <span role="timer">{{h.horario_fim}}</span></span></span>
                    <span class="closed-day text-danger" v-else>Fechado</span>
                  </div>
                </div>
              </section>

              <section class="info-section">
                <h5 class="info-section-title">Prazos e Entrega</h5>
                <div class="info-card order-card">
                <div class="metric-grid" v-if="empresa.tipo_delivery !== '3' || empresa.pedido_minimo > 0">
                  <div class="metric" v-if="empresa.tipo_delivery !== '3'">
                    <span class="section-icon"><icon name="retirada" size="20"/></span>
                    <div><div class="info-label">Retirada no Local</div><strong>{{empresa.media_retirada | tempo}}</strong></div>
                  </div>
                  <div class="metric" v-if="empresa.pedido_minimo > 0">
                    <span class="section-icon"><i class="fa fa-shopping-basket"></i></span>
                    <div><div class="info-label">Pedido mínimo</div><strong>{{empresa.pedido_minimo | valor}}</strong></div>
                  </div>
                </div>
                <div class="free-delivery" v-if="empresa.entrega_gratis === '1' && empresa.tipo_delivery !== '2'">
                  <span class="section-icon"><icon name="cupom" size="20"/></span>
                  <span>
                    <strong class="text-success">Entrega Grátis</strong>
                    <small>
                      <span v-if="empresa.geo_disabled === '0'">Até {{empresa.eg_raio / 1000}}km</span><span v-if="empresa.geo_disabled === '0' && empresa.eg_pedido_minimo > 0"> · </span><span v-if="empresa.eg_pedido_minimo > 0">Pedidos acima de {{empresa.eg_pedido_minimo | valor}}</span>
                      <span v-if="empresa.geo_disabled !== '0' && !(empresa.eg_pedido_minimo > 0)">em todos os Pedidos</span>
                    </small>
                  </span>
                </div>

                <div v-if="empresa.tipo_delivery !== '2'" class="delivery-ranges">
                <div v-if="empresa.geo_disabled === '2'">
                  <div class="range-toggle" :class="{'range-toggle-clickable': empresa.zonas.length > 1}" :role="empresa.zonas.length > 1 ? 'button' : null" :tabindex="empresa.zonas.length > 1 ? 0 : null" @click="empresa.zonas.length > 1 && (entrega_variavel = !entrega_variavel)" @keydown.enter="empresa.zonas.length > 1 && (entrega_variavel = !entrega_variavel)">
                    <div class="range-summary">
                      <span class="section-icon"><icon name="delivery" size="20"/></span>
                      <div>
                        <div class="info-label">Taxas por Região</div>
                        <strong v-if="empresa.zonas.length === 1">
                          <span v-if="zonas[0].taxa_entrega > 0">{{zonas[0].taxa_entrega | valor}}</span>
                          <span class="text-success" v-else>Grátis</span> · {{zonas[0].tempo_entrega | tempo}}
                        </strong>
                        <strong v-else>Consulte valores e prazos</strong>
                      </div>
                    </div>
                    <i class="fa" :class="entrega_variavel ? 'fa-angle-up' : 'fa-angle-down'" v-if="empresa.zonas.length > 1"></i>
                  </div>
                  <div v-for="r in zonas" :key="r.id_zona" class="range-row" v-show="entrega_variavel">
                      <strong>{{r.nome_zona}}</strong>
                      <span>
                        <span v-if="r.taxa_entrega > 0">{{r.taxa_entrega | valor}}</span>
                        <span class="text-success font-weight-bold" v-else>Grátis</span> · {{r.tempo_entrega | tempo}}
                      </span>
                  </div>
                </div>
                <div v-else-if="empresa.raio_entregas.length > 0">
                  <div class="range-toggle" :class="{'range-toggle-clickable': empresa.raio_entregas.length > 1}" :role="empresa.raio_entregas.length > 1 ? 'button' : null" :tabindex="empresa.raio_entregas.length > 1 ? 0 : null" @click="empresa.raio_entregas.length > 1 && (entrega_variavel = !entrega_variavel)" @keydown.enter="empresa.raio_entregas.length > 1 && (entrega_variavel = !entrega_variavel)">
                    <div class="range-summary">
                      <span class="section-icon"><icon name="delivery" size="20"/></span>
                      <div>
                        <div class="info-label">
                          <span v-if="empresa.geo_disabled === '1'">Taxa e Tempo de Entrega</span>
                          <span v-else>Taxas por Distância</span>
                        </div>
                        <strong v-if="empresa.raio_entregas.length === 1">
                          <span v-if="empresa.raio_entregas[0].taxa_entrega > 0">{{empresa.raio_entregas[0].taxa_entrega | valor}}</span>
                          <span class="text-success" v-else>Grátis</span> · {{empresa.raio_entregas[0].tempo_entrega | tempo}}
                        </strong>
                        <strong v-else>Consulte valores e prazos</strong>
                      </div>
                    </div>
                    <i class="fa" :class="entrega_variavel ? 'fa-angle-up' : 'fa-angle-down'" v-if="empresa.raio_entregas.length > 1"></i>
                  </div>
                  <div v-for="(r, index) in empresa.raio_entregas" :key="index" class="range-row" v-show="entrega_variavel">
                      <strong>
                        <span v-if="empresa.geo_disabled === '1'">Condições</span>
                        <span v-else>Até {{r.raio_entrega / 1000}}Km</span>
                      </strong>
                      <span>
                        <span v-if="r.taxa_entrega > 0">{{r.taxa_entrega | valor}}</span>
                        <span class="text-success font-weight-bold" v-else>Grátis</span> · {{r.tempo_entrega | tempo}}
                      </span>
                  </div>
                </div>
                </div>
                </div>
              </section>

            </div>
          </div>
          <div class="mt-4" v-if="empresa.url_facebook || empresa.url_instagram">
            <redes-sociais :empresa="empresa"/>
          </div>
        </div>
        <ads-le-card full="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyHeader from '../components/CompanyHeader'
import Loading from '../components/Loading'
import BottomBar from '../components/BottomBar';
import AdsLeCard from "../components/AdsLeCard";
import RedesSociais from "../components/RedesSociais";
import Icon from "../components/Icon";

export default {
  name: 'InfoRestaurante',
  components: {CompanyHeader, Icon, RedesSociais, AdsLeCard, Loading, BottomBar},
  data() {
    return {
      load: true,
      entrega_variavel: false,
      horarios: []
    }
  },

  methods: {
    getGoogleMapsUrl() {
      const endereco = [
        this.empresa.endereco,
        this.empresa.numero,
        this.empresa.complemento,
        this.empresa.bairro,
        this.empresa.nome_cidade,
        this.empresa.sigla_estado
      ].filter(Boolean).join(', ');

      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
    },

    getDados() {
      this.horarios = ['1','2','3','4','5','6','7'].map(dia => ({
        dia, horarios: this.empresa.horarios.filter(data => data.dia === dia)
      }));

    }
  },

  created() {
    window.scrollTo(0,0);
    document.body.classList.remove("modal-open");
    this.getDados();
    this.load = false;
  },

  computed: {
    pagamentosEntrega() {
      return (this.empresa.pagamentos || []).filter(p => String(p.categoria) !== '5')
    },

    pagamentosOnline() {
      return (this.empresa.pagamentos || []).filter(p => String(p.categoria) === '5')
    },

    googleMapsUrl() {
      return this.getGoogleMapsUrl()
    },

    empresa() {
      return this.$store.state.empresa
    },

    zonas() {
      return [...(this.empresa.zonas || [])].sort((a, b) => {
        const ordemA = parseInt(a.ordem, 10);
        const ordemB = parseInt(b.ordem, 10);
        const posicaoA = ordemA > 0 ? ordemA : Number.MAX_SAFE_INTEGER;
        const posicaoB = ordemB > 0 ? ordemB : Number.MAX_SAFE_INTEGER;

        return posicaoA - posicaoB || parseInt(a.id_zona, 10) - parseInt(b.id_zona, 10);
      })
    },

    usuario() {
      return this.$store.state.dataUser
    }
  },

  filters: {
    phone(phone) {
      if (phone) {
        if (phone.length === 10) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

        } else if (phone.length === 11) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
      }

      return phone
    }
  }
}
</script>
<style scoped>
.container-logo {
  position: relative;
  height: 140px;
  text-align: center;

}

.logo-empresa {
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--lecard-primary)!important;
  border-radius: 18px;
}

.info-body {
  color: #2f3747;
  margin-top: 24px;
}

.info-section + .info-section {
  margin-top: 24px;
}

.info-section-title {
  color: #202736;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 10px;
}

.info-card,
.contact-action {
  background: #fff;
  border: 0;
  border-radius: 16px;
  box-shadow: var(--shadow);
}

.info-card {
  padding: 14px;
}

.info-card-row,
.metric,
.contact-action,
.payment-item {
  display: flex;
  align-items: center;
}

.section-icon,
.contact-icon {
  align-items: center;
  background: transparent;
  color: var(--lecard-primary);
  display: flex;
  flex: 0 0 32px;
  font-size: 20px;
  height: 32px;
  justify-content: center;
  margin-right: 12px;
  width: 32px;
}

.info-label,
.contact-action small,
.payment-item small {
  color: #7b8290;
  display: block;
  font-size: 12px;
  line-height: 1.35;
}

.info-value {
  font-size: 14px;
  line-height: 1.55;
}

.location-action {
  color: #2f3747;
  text-decoration: none !important;
}

.contact-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.contact-action {
  color: #202736;
  min-width: 0;
  padding: 14px;
  text-decoration: none !important;
}

.contact-action strong {
  display: block;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contact-action.whatsapp .contact-icon {
  background: transparent;
  color: var(--lecard-primary);
}

.action-arrow {
  color: var(--lecard-primary);
  margin-left: auto;
  padding-left: 8px;
}

.metric-grid {
  display: grid;
  gap: 0;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  padding: 14px;
}

.order-card {
  overflow: hidden;
  padding: 0;
}

.metric {
  min-width: 0;
  padding: 0 14px;
}

.metric:first-child {
  padding-left: 0;
}

.metric + .metric {
  border-left: 1px solid #eceef2;
}

.metric strong {
  font-size: 14px;
}

.free-delivery {
  align-items: center;
  background: #fff;
  border: 1px solid #eceef2;
  border-color: #eceef2;
  border-left: 0;
  border-radius: 0;
  border-right: 0;
  color: #202736;
  display: flex;
  font-size: 14px;
  padding: 14px 16px;
}

.free-delivery strong,
.free-delivery small {
  display: block;
}

.free-delivery small {
  color: #7b8290;
  margin-top: 2px;
}

.delivery-ranges {
  background: #fff;
  border: 0;
  border-radius: 0;
  overflow: hidden;
}

.order-card .metric-grid + .delivery-ranges {
  border-top: 1px solid #eceef2;
}

.range-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #2f3747;
  display: flex;
  justify-content: space-between;
  padding: 13px 15px;
  text-align: left;
  width: 100%;
}

.range-toggle small {
  color: #7b8290;
}

.range-summary {
  align-items: center;
  display: flex;
}

.range-toggle-clickable {
  cursor: pointer;
}

.range-row,
.schedule-row {
  align-items: center;
  display: flex;
  font-size: 13px;
  justify-content: space-between;
  padding: 12px 15px;
}

.range-row + .range-row,
.range-toggle + .range-row,
.schedule-row + .schedule-row {
  border-top: 1px solid #eceef2;
}

.payment-groups {
  background: transparent;
  box-shadow: none;
  display: grid;
  gap: 10px;
  padding: 0;
}

.payment-group {
  background: #fff;
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 14px;
}

.payment-group-title {
  margin-bottom: 12px;
}

.payment-grid {
  display: grid;
  gap: 10px 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.payment-item {
  font-size: 13px;
  min-width: 0;
}

.payment-logo {
  align-items: center;
  border: 0;
  display: flex;
  flex: 0 0 42px;
  height: 34px;
  justify-content: center;
  margin-right: 10px;
  width: 42px;
}

.payment-logo img {
  height: 20px;
  max-width: 30px;
  object-fit: contain;
}

.schedule-card {
  overflow: hidden;
  padding: 2px 14px;
}

.schedule-card .schedule-row {
  padding-left: 0;
  padding-right: 0;
}

.schedule-row strong {
  color: #202736;
}

.schedule-row > span {
  color: #626a78;
  text-align: right;
}

.schedule-row > .closed-day {
  color: #7b8290;
  font-weight: 500;
}

@media (max-width: 575px) {
  .contact-grid,
  .payment-grid {
    grid-template-columns: 1fr;
  }

  .metric-grid {
    grid-template-columns: 1fr;
  }

  .metric {
    padding: 12px 0;
  }

  .metric:first-child {
    padding-top: 0;
  }

  .metric:last-child {
    padding-bottom: 0;
  }

  .metric + .metric {
    border-left: 0;
    border-top: 1px solid #eceef2;
  }
}

@media (min-width: 768px) {
  .container-logo {
    height: 280px;
  }

  .logo-empresa {
    border: 3px solid #ffffff;
    border-radius: 18px;
  }

}
</style>
